import React from "react";
import "../../Stylesheets/ShowCasingCapability/ShowCasingCapability.scss";
import website from "../../assests/Images/Showcase/website.png";
import map from "../../assests/Images/Showcase/googlemap.png";
import media from "../../assests/Images/Showcase/socialmedia.png";
import kiosks from "../../assests/Images/Showcase/kiosks.png";

const ShowCasingCapability = () => {
  return (
    <div className="showcase-main-wrapper">
      <div className="showcase-inner-wrapper">
        <div className="showcase-heading">
          <button>
            <span className="head-text">Showcasing Capability</span>
          </button>
        </div>

        <div className="showcase-content-wrap">
          <div className="showcase-card-wrap">
            <div class="row g-4">
              {/* <div className="col"> */}
              {/* <div className="row card"> */}
              <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 whole_containshow">
                <div className="background_showcase">
                  <img src={website}></img>
                  <div className=" text_showcasing">Website</div>
                </div>
              </div>
              {/* </div> */}
              {/* </div> */}
              {/* <div className="col"> */}
              {/* <div className="row card"> */}
              <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 whole_containshow">
                <div className="background_showcase">
                  <img src={map}></img>
                  <div className="text_showcasing">Google Maps</div>
                </div>
              </div>
              {/* </div> */}
              {/* </div> */}
              {/* <div className="col"> */}
              {/* <div className="row card"> */}
              <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 whole_containshow">
                <div className="background_showcase">
                  <img src={media}></img>
                  <div className="text_showcasing">Social Media</div>
                </div>
              </div>
              {/* </div> */}
              {/* </div> */}
              {/* <div className="col"> */}
              {/* <div className="row card"> */}
              <div className="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 whole_containshow">
                <div className="background_showcase">
                  <img src={kiosks}></img>
                  <div className="text_showcasing">Kiosks</div>
                </div>
              </div>
              {/* </div> */}
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShowCasingCapability;
